import ToastMsg from "../helper/ToastMsg";

export const recordEvent = ({ eventName, eventParams, userId }) => {
  // Set Customer User ID
  if (window.app) {
    console.log("User ID:", userId);
    if (
      userId 
    ) {
      window.app.setCustomerUserId(userId);
    }
    const properties = eventParams || {};
    window.app.recordEvent(eventName, properties);
    console.log("Event recorded successfully! Event Name: " + eventName);
    console.log("Event Properties: ", properties);
    // ToastMsg("Event recorded successfully! Event Name: " + eventName, "success");
  }
};

export const getAppsFlyerId = (userId) => {
  if (window.app) {
    window.app.setCustomerUserId(userId);

    const appsFlyerId = window.app.getAppsFlyerId();
    console.log("AppsFlyer ID:", appsFlyerId);
    // ToastMsg("AppsFlyer ID: " + appsFlyerId, "success");
    return appsFlyerId;
  }
  // ToastMsg("App interface not available", "error");
  return null;
};
